import React, { ReactNode, useState, useEffect } from 'react';
import { motion } from 'motion/react';

interface ScrollRevealProps {
  children: ReactNode;
  delay?: number;
  yOffset?: number;
  duration?: number;
  className?: string;
  as?: 'div' | 'section';
}

export function ScrollReveal({ 
  children, 
  delay = 0, 
  yOffset = 20, 
  duration = 0.5,
  className = "",
  as = 'div'
}: ScrollRevealProps) {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    // Safety fallback: ensure content is ALWAYS visible even if IntersectionObserver fails or is blocked in an iframe
    const timer = setTimeout(() => {
      setHasMounted(true);
    }, 250);
    return () => clearTimeout(timer);
  }, []);

  const Component = as === 'section' ? motion.section : motion.div;

  return (
    <Component
      initial={{ opacity: 0, y: yOffset }}
      whileInView={{ opacity: 1, y: 0 }}
      animate={hasMounted ? { opacity: 1, y: 0 } : undefined}
      viewport={{ once: true, amount: 0.01 }}
      transition={{ duration, delay, ease: "easeOut" }}
      className={className}
    >
      {children}
    </Component>
  );
}
